// Телефонът на госта като връзка за набиране — един компонент за модула
// „Резервации" и справките за резервациите (поповърът на масата, картата в
// списъка, „Дневник", „Гости" и историята на госта). Видимият текст е
// телефонът, както е записан; адресът е `telHref`. В „Маркиране" НЕ се
// ползва — там телефонът остава текст.
//
// Тиха връзка: цветът идва от мястото (наследява се), бледото подчертаване
// казва „натисни" и на тъч екран, а hover-ът я оцветява в кехлибарено.
// antd оцветява ВСЯКО `<a>` в colorLink с правило извън Tailwind layer-ите,
// затова мястото (`className`) е на обвивката, а цветовете на връзката са с
// `!` — иначе телефонът е винаги кехлибарен и hover-ът не личи.
// Кликът не стига до родителя — картата/редът под телефона има собствен клик.
// Групата е именувана (`group/phone`), за да не я пали hover на родител с `group`.

import type { MouseEvent } from "react";
import { PhoneOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { telHref } from "./telHref";

type Props = {
  phone: string;
  /** Слушалка пред номера — там, където наоколо няма етикет „Телефон". */
  withIcon?: boolean;
  /** Размер, шрифт, цвят и разположение — от мястото, където стои. */
  className?: string;
};

const keepClickOnLink = (event: MouseEvent) => event.stopPropagation();

const PhoneLink = ({ phone, withIcon = false, className = "" }: Props) => {
  const { t } = useTranslation();
  const href = telHref(phone);
  // Без цифри няма какво да се набере — показва се текстът, както е записан.
  if (!href) return phone.trim() ? <span className={`tabular-nums ${className}`}>{phone}</span> : null;

  const label = t("common.callPhone", { phone });
  return (
    <span className={`inline-flex min-w-0 max-w-full ${className}`}>
      <a
        href={href}
        aria-label={label}
        title={label}
        onClick={keepClickOnLink}
        // -my-1 py-1: по-голяма цел за пръста, без редът да порасне.
        className="group/phone -my-1 inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-[4px] py-1 tabular-nums !text-inherit outline-none transition-colors duration-150 hover:!text-brand-deep-ink focus-visible:shadow-[0_0_0_2px_var(--color-brand)]"
      >
        {/* Слушалката е в цвета на връзката — antd иконите наследяват цвета си
            (като съседната иконка за гостите). */}
        {withIcon && <PhoneOutlined aria-hidden className="shrink-0 text-[11px]" />}
        <span className="truncate underline decoration-shade-4 underline-offset-2 transition-colors duration-150 group-hover/phone:decoration-brand">
          {phone}
        </span>
      </a>
    </span>
  );
};

export default PhoneLink;
